import { CronScheduleProps } from './types'
import { ISchedule, IScheduleEvent } from './interfaces'
import { CronSchedule } from './Schedule'

const debug = !process.env.AWS_SESSION_TOKEN && false

export type ScheduleEventProps = {
  startMs?: number
  stopMs?: number
  positiveSchedules: CronScheduleProps[]
}

export class ScheduleEvent implements IScheduleEvent, ScheduleEventProps {
  constructor({ positiveSchedules, startMs, stopMs }: ScheduleEventProps) {
    this.positiveSchedules = positiveSchedules.map((cronScheduleProps) => new CronSchedule(cronScheduleProps))
    this.startMs = startMs
    this.stopMs = stopMs
  }

  positiveSchedules: CronSchedule[]
  startMs?: number
  stopMs?: number

  getOccurances = (fromMs: number, toMs: number) => {
    const from = Math.max(this.startMs ?? 0, fromMs)
    const to = Math.min(this.stopMs ?? Infinity, toMs)
    debug &&
      console.log(
        `ScheduleEvent getOccurences with  ${new Date(fromMs).toString()} and ${new Date(toMs).toString()} using ${new Date(from).toString()}  to ${new Date(to).toString()}`,
      )
    this.stopMs && debug && console.log(`ScheduleEvent getOccurences this.stopMs is date ${new Date(this.stopMs).toString()} `)
    const res: number[] = this.positiveSchedules.reduce((acc, curr) => {
      return [...acc, ...curr.getOccurances(from, to)]
    }, [] as number[])

    debug && console.log('positiveSchedules', this.positiveSchedules)
    return res.sort()
  }

  getOccuranceDatesLocal = (fromMs: number, toMs: number) => {
    return this.getOccurances(fromMs, toMs).map((ms) => new Date(ms).toString())
  }

  addSchedule = (schedule: CronScheduleProps) => {
    this.positiveSchedules.push(new CronSchedule(schedule))
  }

  removeSchedule = (scheduleId: string) => {
    const idx = this.positiveSchedules.findIndex((schedule) => schedule.id === scheduleId)
    if (idx !== -1) {
      this.positiveSchedules.splice(idx, 1)
    }
  }
}
